module.exports = __webpack_public_path__ + "img/slots.9aba625f.svg";